<template>
  <div class="ccui-app-box-iframe-operate-container">
    <breadcrumbSourcing :breadcrumb-data="breadcrumbData"></breadcrumbSourcing>
    <div class="ccui-app-iframe-container-detail">
      <div class="ccui-app-iframe-container-detail-body">
        <div class="ccui-tab-iframe">
          <div class="ccui-tab-wrapper">
            <el-button type="table-top-active" size="mini">{{
              `${skillAndCommonTemp ? "技术商务评分" : "商务评分"}${
                subPackageFlag == "0" ? "" : "(包件：" + packName + ")"
              }`
            }}</el-button>
          </div>
        </div>
        <div class="exportStyle">
          <el-button type="single-number" v-preventReClick @click="exportExcel"
            >导出</el-button
          >
          <el-upload
            ref="importExcel1"
            class="upload-demo tow"
            :data="uploadFormData"
            :action="uploadForm.action"
            :on-success="uploadSuccess"
            :show-file-list="false"
            :on-error="uploadError"
            :before-upload="beforeAvatarUpload"
            :headers="uploadForm.headers"
            multiple
          >
            <el-button type="single-number">导入</el-button>
          </el-upload>
        </div>
        <el-table
          :data="tableData"
          border
          :empty-text="
            `该${
              purchaseType == 1 ||
              purchaseType == 2 ||
              purchaseType == 4 ||
              purchaseType == 7 ||
              purchaseType == 8
                ? '评审'
                : '评标'
            }项目中，没有有效的分包商${
              purchaseType == 1 ||
              purchaseType == 2 ||
              purchaseType == 4 ||
              purchaseType == 7 ||
              purchaseType == 8
                ? '响应'
                : '投标'
            }信息！`
          "
        >
          <template v-for="(item, index) in columns">
            <el-table-column
              :key="index"
              :show-overflow-tooltip="true"
              v-bind="item"
              v-if="item.labelChild && item.labelChild.length > 0"
            >
              <template slot="header">
                <template v-if="item.required">
                  <span class="star">*</span>{{ item.label }}
                </template>
                <template v-else>{{ item.label }}</template>
              </template>
              <template v-if="item.labelChild && item.labelChild.length > 0">
                <el-table-column
                  v-for="(child, indexch) in item.labelChild"
                  :key="indexch"
                  align="center"
                  v-bind="child"
                >
                  <template
                    v-if="child.labelChild && child.labelChild.length > 0"
                  >
                    <el-table-column
                      v-for="(childTwo, indexchTwo) in child.labelChild"
                      :key="indexchTwo"
                      align="center"
                      v-bind="childTwo"
                    >
                      <template slot="header">
                        <div class="el-tooltip">{{ childTwo.label }}</div>
                      </template>
                      <template slot-scope="scope">
                        <el-input
                          v-if="child.type == 'input'"
                          v-model="scope.row[scope.column.property]"
                          v-limitdecimal.two
                          @change="
                            changeScore(
                              $event,
                              scope.column.property,
                              scope.$index
                            )
                          "
                          :min="0"
                          size="mini"
                        ></el-input>
                      </template>
                    </el-table-column>
                  </template>
                </el-table-column>
              </template>
              <template slot-scope="scope">
                <el-input
                  maxlength="150"
                  show-word-limit
                  class="input-short word-limit input-width;"
                  v-if="item.type == 'input'"
                  v-model="scope.row.scoreDesc"
                ></el-input>
                <el-button
                  v-else-if="item.type == 'link'"
                  size="mini"
                  type="text"
                  @click="viewBidFile(scope.row)"
                  >{{
                    `查看${
                      purchaseType == 1 ||
                      purchaseType == 2 ||
                      purchaseType == 4 ||
                      purchaseType == 7 ||
                      purchaseType == 8
                        ? "响应"
                        : "投标"
                    }文件`
                  }}</el-button
                >
                <span v-else-if="item.money">{{
                  scope.row[item.prop]
                    ? new BigNumber(scope.row[item.prop]).toFormat(2)
                    : ""
                }}</span>
                <span v-else-if="item.prop == 'supScore'">{{
                  scope.row[item.prop]
                    ? new BigNumber(scope.row[item.prop]).toFormat(2)
                    : "0.00"
                }}</span>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :key="index"
              :show-overflow-tooltip="true"
              v-bind="item"
              v-else-if="!item.labelChild"
            >
              <template slot="header">
                <template v-if="item.required">
                  <span class="star">*</span>{{ item.label }}
                </template>
                <template v-else>{{ item.label }}</template>
              </template>
              <template slot-scope="scope">
                <el-input
                  maxlength="150"
                  show-word-limit
                  class="input-short word-limit input-width;"
                  v-if="item.type == 'input'"
                  v-model="scope.row.scoreDesc"
                ></el-input>
                <el-button
                  v-else-if="item.type == 'link'"
                  size="mini"
                  type="text"
                  @click="viewBidFile(scope.row)"
                  >{{
                    `查看${
                      purchaseType == 1 ||
                      purchaseType == 2 ||
                      purchaseType == 4 ||
                      purchaseType == 7 ||
                      purchaseType == 8
                        ? "响应"
                        : "投标"
                    }文件`
                  }}</el-button
                >
                <span v-else-if="item.prop == 'supScore'">{{
                  scope.row[item.prop]
                    ? new BigNumber(scope.row[item.prop]).toFormat(2)
                    : "0.00"
                }}</span>
                <span v-else-if="item.money">{{
                  new BigNumber(scope.row[item.prop]).toFormat(2)
                }}</span>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
    </div>
    <div class="operate">
      <el-button
        type="text"
        icon="icon-ccui-save"
        v-preventReClick
        @click="dealExpertSupScore"
        >保存</el-button
      >
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :title="
        `分包商${
          purchaseType == 1 ||
          purchaseType == 4 ||
          purchaseType == 7 ||
          purchaseType == 8
            ? '响应'
            : '投标'
        }详细信息`
      "
      width="1200px"
      v-if="dialogVisible"
    >
      <supplierBidDetails
        :supQuoteId="formData.supQuoteId"
        :supPackQuoteId="formData.supPackQuoteId"
        :supCode="formData.supCode"
        :packId="formData.packId"
      ></supplierBidDetails>
      <div slot="footer"></div>
    </el-dialog>
  </div>
</template>
<script>
import BigNumber from "bignumber.js";
import supplierBidDetails from "@/app/subSourcingFlow/views/supplierBidDetails.vue";
import breadcrumbSourcing from "@/app/subSourcingFlow/components/breadcrumb-sourcing.vue";
import {
  scpQryExpertSupPackQuoteToScoreApi,
  scpDealExpertSupScoreApi,
  scpQryExpertSupPackQuoteScoreApi,
  scpListPurchaseSchemePackageApi,
  scpExportSupQuoteScoreFile,
  scpQrySupComCheckListApi
} from "@/app/sourcingFlow/api/scp-expertEvaluation.js";
import Cookies from "js-cookie";
export default {
  name: "addCommercialGrade",
  components: {
    supplierBidDetails,
    breadcrumbSourcing
  },
  props: {
    type: {
      type: Number,
      default: 0 // type 0:新增 1：编辑
    },
    packId: {
      type: String,
      default: "" // 包件packId
    },
    skillAndCommon: {
      type: Boolean,
      default: false // false:商务评分  true:商务技术评分
    }
  },
  watch: {
    skillAndCommon(val) {
      this.skillAndCommonTemp = val;
    },
    purchaseType: {
      handler(newVal) {
        if (newVal == 1 || newVal == 4 || newVal == 7 || newVal == 8) {
          this.columnsFree.forEach(item => {
            if (item.prop == "查看投标文件") {
              item.label = "响应文件";
            }
          });
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    let unit = JSON.parse(sessionStorage.getItem("moneyData")).unit;
    return {
      purchaseType: JSON.parse(sessionStorage.getItem("expertSourceData"))
        .purchaseType, // 招标方式
      getqrySupComCheckList: [],
      BigNumber: BigNumber,
      skillAndCommonTemp: this.$router.history.current.query.skillAndCommon
        ? this.$router.history.current.query.skillAndCommon
        : this.skillAndCommon,
      breadcrumbData: {
        titname: this.skillAndCommonTemp ? "技术商务评分" : "商务评分"
      },
      tableData: [],
      headers: [], // 商务表头
      skiiHeaders: [], // 商务技术打分的时候技术表头
      dialogVisible: false,
      formData: {
        supQuoteId: 0, // 分包商报价ID
        supPackQuoteId: "",
        supCode: "", // 分包商编号
        packId: "" //包件id
      },
      columns: [],
      columnsFree: Object.freeze([
        {
          prop: "id",
          label: "序号",
          width: 55,
          fixed: true
        },
        {
          prop: "supName",
          label: "分包商",
          width: 200,
          fixed: true
        },
        {
          prop: "industryTypeName",
          label: "行业类型",
          width: 120
        },
        {
          prop: "companyTypeName",
          label: "企业规模",
          width: 120
        },
        {
          prop: "taxAmount",
          label: "税额（" + unit + "）",
          width: 180,
          align: "right",
          money: true
        },
        {
          prop: "noTaxPriceAmount",
          label: "不含税金额（" + unit + "）",
          width: 200,
          align: "right",
          money: true
        },
        {
          prop: "priceAmount",
          label: "含税金额（" + unit + "）",
          width: 180,
          align: "right",
          money: true
        },
        {
          prop: "查看投标文件",
          label: "投标文件",
          width: 170,
          type: "link"
        },
        {
          prop: "sscSkillScoreItemBOS",
          label: "技术",
          labelChild: [],
          required: true,
          align: "center"
        },
        {
          prop: "sscSkillScoreItemBOS",
          label: "技术加分项",
          labelChild: [],
          required: true,
          align: "center"
        },
        {
          prop: "sscScoreItemBOS",
          label: "商务",
          labelChild: [],
          align: "center",
          required: true
        },
        {
          prop: "sscScoreItemBOS",
          label: "商务加分项",
          labelChild: [],
          align: "center",
          required: true
        },

        {
          prop: "supScore",
          label: "汇总得分",
          width: 110
          // money: true
        },
        {
          prop: "scoreDesc",
          label: "打分说明",
          width: 350,
          type: "input"
        }
      ]),
      packName: "",
      subPackageFlag: "1", // 是否分包 1分包0不分包
      uploadForm: {
        action: this.$addUrlPerFix(
          process.env.VUE_APP_BASE_URL +
            "/apis/bid-scp/bidc/getImportExpertScoreContent"
        ),
        headers: {
          Authorization: Cookies.get("access_token") || ""
        }
      },
      uploadFormData: {}
    };
  },
  mounted() {
    this.breadcrumbData.titname = this.skillAndCommonTemp
      ? "技术商务评分"
      : "商务评分";
    let expertSourceData = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    );
    this.purchaseType = expertSourceData.purchaseType;
    if (this.purchaseType == "50" || this.purchaseType == "53") {
      if (!this.skillAndCommonTemp) {
        this.columns = this.columnsFree.filter(
          n => n.prop !== "sscSkillScoreItemBOS" && n.prop !== "priceAmount"
        );
      } else {
        this.columns = this.columnsFree.filter(n => n.prop !== "priceAmount");
      }
    } else {
      if (!this.skillAndCommonTemp) {
        this.columns = this.columnsFree.filter(
          n => n.prop !== "sscSkillScoreItemBOS"
        );
      } else {
        this.columns = this.columnsFree.map(n => n);
      }
    }

    this.cumputeData();
    this.getPackData();
  },
  created() {
    scpQrySupComCheckListApi({
      schemeId: JSON.parse(sessionStorage.getItem("expertSourceData")).schemeId,
      systemFlag: 0,
      joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
        .joinExpertId,
      purStep: this.$router.history.current.query.menuKey,
      evaPurStep: this.$router.history.current.query.evaPurStep
    }).then(res => {
      if (res.data.code === "0") {
        this.getqrySupComCheckList = res.data.data.rows;
        // 通过包件id进行排序
        console.log("data", res.data.data.rows);
        console.log("getqrySupComCheckList", this.getqrySupComCheckList);
      }
    });
  },
  methods: {
    cumputeData() {
      if (
        this.$router.history.current.query.type &&
        this.$router.history.current.query.type == "1"
      ) {
        scpQryExpertSupPackQuoteScoreApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: this.packId
            ? this.packId
            : this.$router.history.current.query.packId,
          joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .joinExpertId,
          scoreItem: this.skillAndCommonTemp ? "" : "1"
        }).then(res => {
          if (res.data.data && res.data.data.length > 0) {
            if (this.skillAndCommonTemp) {
              // this.columns.splice(5, 0, {
              //   prop: "sscSkillScoreItemBOS",
              //   label: "技术",
              //   labelChild: [],
              //   required: true,
              //   align: "center"
              // });
            }
            // let labelChild = []; //商务 1
            // let labelChild2 = []; //技术加分项 2
            // let labelChild3 = []; //商务加分项 3
            // let labelSkillChild = []; //技术 0
            let labelChild = [];
            let labelChild2 = [];
            let labelChild3 = [];
            let labelSkillChild = [];
            res.data.data.forEach((item, index) => {
              item.id = index + 1;
              if (!item.supScore) {
                item.supScore = 0;
              }
              item.sscScoreBOS = item.sscSupScoreBOS;
              item.sscScoreBOS.forEach(aItem => {
                aItem.sscScoreItemBOS = aItem.sscSupScoreItemBOS;
                aItem.sscScoreItemBOS.forEach(bItem => {
                  if (!bItem.supScore) {
                    bItem.supScore = 0;
                  }
                  item.scoreRule = bItem.scoreRule;
                  item.scoreWeight = bItem.scoreWeight;
                  item.scoreStandard = bItem.scoreStandard;
                  let props =
                    "supScore-" + aItem.scoreItem + "-" + bItem.scoreItemId;
                  item[props] =
                    bItem.supScore && new BigNumber(bItem.supScore).toFormat(2);
                  // 细则权重
                  let scoreWeightProps =
                    "maxScoreWeight-" +
                    aItem.scoreItem +
                    "-" +
                    bItem.scoreRule +
                    "-" +
                    bItem.scoreItemId;
                  item[scoreWeightProps] = bItem.scoreWeight;
                  if (aItem.scoreItem === "0") {
                    if (
                      labelSkillChild.filter(item => {
                        return (
                          item.prop ==
                          "supScore-" +
                            aItem.scoreItem +
                            "-" +
                            bItem.scoreItemId
                        );
                      }).length == 0
                    ) {
                      labelSkillChild.push({
                        prop: props,
                        label: bItem.scoreRule,
                        width: 120,
                        type: "input",
                        labelChild: [
                          {
                            prop: props,
                            label: "细则权重:" + bItem.scoreWeight,
                            width: 120,
                            money: true
                            // labelChild: [
                            //   {
                            //     prop: props,
                            //     label: "评分规则内容",
                            //     width: 120
                            //   }
                            // ]
                          }
                        ]
                      });
                    }
                  }
                  if (aItem.scoreItem === "1") {
                    if (
                      labelChild.filter(item => {
                        return (
                          item.prop ==
                          "supScore-" +
                            aItem.scoreItem +
                            "-" +
                            bItem.scoreItemId
                        );
                      }).length == 0
                    ) {
                      labelChild.push({
                        prop: props,
                        label: bItem.scoreRule,
                        width: 120,
                        type: "input",
                        labelChild: [
                          {
                            prop: props,
                            label: "细则权重:" + bItem.scoreWeight,
                            width: 120,
                            money: true
                            // labelChild: [1
                            //   {
                            //     prop: props,
                            //     label: "评分规则内容",
                            //     width: 120
                            //   }
                            // ]
                          }
                        ]
                      });
                    }
                  }
                  if (aItem.scoreItem === "2") {
                    if (
                      labelChild2.filter(item => {
                        return (
                          item.prop ==
                          "supScore-" +
                            aItem.scoreItem +
                            "-" +
                            bItem.scoreItemId
                        );
                      }).length == 0
                    ) {
                      labelChild2.push({
                        prop: props,
                        label: bItem.scoreRule,
                        width: 120,
                        type: "input",
                        labelChild: [
                          {
                            prop: props,
                            label: "细则权重:" + bItem.scoreWeight,
                            width: 120,
                            money: true
                          }
                        ]
                      });
                    }
                  }
                  if (aItem.scoreItem === "3") {
                    if (
                      labelChild3.filter(item => {
                        return (
                          item.prop ==
                          "supScore-" +
                            aItem.scoreItem +
                            "-" +
                            bItem.scoreItemId
                        );
                      }).length == 0
                    ) {
                      labelChild3.push({
                        prop: props,
                        label: bItem.scoreRule,
                        width: 120,
                        type: "input",
                        labelChild: [
                          {
                            prop: props,
                            label: "细则权重:" + bItem.scoreWeight,
                            width: 120,
                            money: true
                          }
                        ]
                      });
                    }
                  }
                });
              });
            });
            // if (labelChild.length + labelSkillChild.length < 3) {
            // if (this.skillAndCommonTemp) {
            //   delete this.columns[7].width;
            // } else {
            //   delete this.columns[6].width;
            // }
            // }
            // let labelChild = []; //商务 1
            // let labelChild2 = []; //技术加分项 2
            // let labelChild3 = []; //商务加分项 3
            // let labelSkillChild = []; //技术 0
            // this.columns[8].labelChild = labelChild;
            // this.columns[9].labelChild = labelChild3;
            this.columns[8].labelChild = labelChild;
            this.columns[9].labelChild = labelChild3;
            if (this.skillAndCommonTemp) {
              this.columns[8].labelChild = labelSkillChild;
              this.columns[9].labelChild = labelChild2;
              this.columns[10].labelChild = labelChild;
              this.columns[11].labelChild = labelChild3;
            }
            this.tableData = res.data.data;
          }
        });
      } else {
        scpQryExpertSupPackQuoteToScoreApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: this.packId
            ? this.packId
            : this.$router.history.current.query.packId,
          scoreItem: this.skillAndCommonTemp ? "" : "1"
        }).then(res => {
          if (res.data.data && res.data.data.length > 0) {
            let labelChild = []; //商务 1
            let labelChild2 = []; //技术加分项 2
            let labelChild3 = []; //商务加分项 3
            let labelSkillChild = []; //技术 0
            res.data.data.forEach((item, index) => {
              item.id = index + 1;
              if (!item.supScore) {
                item.supScore = 0;
              }
              item.sscScoreBOS.forEach(sscScoreBOItem => {
                sscScoreBOItem.sscScoreItemBOS.forEach(sscScoreItemBO => {
                  if (!sscScoreItemBO.supScore) {
                    sscScoreItemBO.supScore = 0;
                  }
                  item.scoreRule = sscScoreItemBO.scoreRule;
                  item.scoreWeight = sscScoreItemBO.scoreWeight;
                  item.scoreStandard = sscScoreItemBO.scoreStandard;
                  let props =
                    "supScore-" +
                    sscScoreBOItem.scoreItem +
                    "-" +
                    sscScoreItemBO.scoreItemId;
                  item[props] = sscScoreItemBO.supScore;
                  // 细则权重
                  let scoreWeightProps =
                    "maxScoreWeight-" +
                    sscScoreBOItem.scoreItem +
                    "-" +
                    sscScoreItemBO.scoreRule +
                    "-" +
                    sscScoreItemBO.scoreItemId;
                  item[scoreWeightProps] =
                    sscScoreItemBO.scoreWeight &&
                    new BigNumber(sscScoreItemBO.scoreWeight).toFormat(2);
                  if (sscScoreBOItem.scoreItem === "0") {
                    if (
                      labelSkillChild.filter(item => {
                        return (
                          item.prop ==
                          "supScore-" +
                            sscScoreBOItem.scoreItem +
                            "-" +
                            sscScoreItemBO.scoreItemId
                        );
                      }).length == 0
                    ) {
                      labelSkillChild.push({
                        prop: props,
                        label: sscScoreItemBO.scoreRule,
                        width: 120,
                        type: "input",
                        labelChild: [
                          {
                            prop: props,
                            label: "细则权重:" + sscScoreItemBO.scoreWeight,
                            width: 120,
                            money: true
                            // labelChild: [
                            //   {
                            //     prop: props,
                            //     label: "评分规则内容",
                            //     width: 120
                            //   }
                            // ]
                          }
                        ]
                      });
                    }
                  }
                  if (sscScoreBOItem.scoreItem === "1") {
                    if (
                      labelChild.filter(item => {
                        return (
                          item.prop ==
                          "supScore-" +
                            sscScoreBOItem.scoreItem +
                            "-" +
                            sscScoreItemBO.scoreItemId
                        );
                      }).length == 0
                    ) {
                      labelChild.push({
                        prop: props,
                        label: sscScoreItemBO.scoreRule,
                        width: 120,
                        type: "input",
                        labelChild: [
                          {
                            prop: props,
                            label: "细则权重:" + sscScoreItemBO.scoreWeight,
                            width: 120,
                            money: true
                            // labelChild: [
                            //   {
                            //     prop: props,
                            //     label: "评分规则内容",
                            //     width: 120
                            //   }
                            // ]
                          }
                        ]
                      });
                    }
                  }
                  if (sscScoreBOItem.scoreItem === "2") {
                    if (
                      labelChild2.filter(item => {
                        return (
                          item.prop ==
                          "supScore-" +
                            sscScoreBOItem.scoreItem +
                            "-" +
                            sscScoreItemBO.scoreItemId
                        );
                      }).length == 0
                    ) {
                      labelChild2.push({
                        prop: props,
                        label: sscScoreItemBO.scoreRule,
                        width: 120,
                        type: "input",
                        labelChild: [
                          {
                            prop: props,
                            label: "细则权重:" + sscScoreItemBO.scoreWeight,
                            width: 120,
                            money: true
                          }
                        ]
                      });
                    }
                  }
                  if (sscScoreBOItem.scoreItem === "3") {
                    if (
                      labelChild3.filter(item => {
                        return (
                          item.prop ==
                          "supScore-" +
                            sscScoreBOItem.scoreItem +
                            "-" +
                            sscScoreItemBO.scoreItemId
                        );
                      }).length == 0
                    ) {
                      labelChild3.push({
                        prop: props,
                        label: sscScoreItemBO.scoreRule,
                        width: 120,
                        type: "input",
                        labelChild: [
                          {
                            prop: props,
                            label: "细则权重:" + sscScoreItemBO.scoreWeight,
                            width: 120,
                            money: true
                          }
                        ]
                      });
                    }
                  }
                });
              });
            });
            console.log(labelChild, labelChild2, labelChild3, labelSkillChild);
            // let labelChild = []; //商务 1
            // let labelChild2 = []; //技术加分项 2
            // let labelChild3 = []; //商务加分项 3
            // let labelSkillChild = []; //技术 0
            this.columns[8].labelChild = labelChild;
            this.columns[9].labelChild = labelChild3;
            if (this.skillAndCommonTemp) {
              // 组合评分
              this.columns[8].labelChild = labelSkillChild;
              this.columns[9].labelChild = labelChild2;
              this.columns[10].labelChild = labelChild;
              this.columns[11].labelChild = labelChild3;
            }
            this.tableData = res.data.data;
          }
          console.log(this.columns);
        });
      }
    },
    getPackData() {
      scpListPurchaseSchemePackageApi({
        pageNo: -1,
        pageSize: -1,
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        // subPackageFlag 是否分包 1分包0不分包
        this.subPackageFlag = res.data.data.subPackageFlag;
        let packId = this.packId
          ? this.packId
          : this.$router.history.current.query.packId;
        res.data.data.purchaseSchemePackageList.forEach(item => {
          if (item.packId == packId) {
            this.packName = item.packName;
          }
        });
      });
    },
    viewBidFile(row) {
      console.log(row, "row..");
      this.formData.supQuoteId = row.supQuoteId;
      this.formData.supPackQuoteId = row.supPackQuoteId;
      this.formData.supCode = row.supCode;
      this.formData.packId = this.packId
        ? this.packId
        : this.$router.history.current.query.packId;
      this.dialogVisible = true;
    },
    // 改变分数计算汇总得分
    changeScore(value, prop, index) {
      let total = 0;
      let flag = true;
      let message = "";
      try {
        for (let key in this.tableData[index]) {
          if (key.includes("supScore-")) {
            // 不能大于权重大小
            for (let keyWeight in this.tableData[index]) {
              if (keyWeight.includes("maxScoreWeight-")) {
                let scoreItem = key.substring(9, 10);
                let scoreWeightItem = keyWeight.substring(15, 16);
                let scoreItemId = key.substring(11);
                let scoreWeightItemId = keyWeight.substring(
                  keyWeight.lastIndexOf("-") + 1
                );
                let scoreRule = keyWeight.substring(
                  17,
                  keyWeight.lastIndexOf("-")
                );
                if (
                  scoreItem === scoreWeightItem &&
                  scoreItemId === scoreWeightItemId
                ) {
                  if (
                    Number(this.tableData[index][key]) >
                    Number(this.tableData[index][keyWeight])
                  ) {
                    flag = false;
                    this.tableData[index][prop] = 0;
                    message =
                      "第" +
                      (index + 1) +
                      "行的" +
                      scoreRule +
                      "的得分不允许大于细则权重" +
                      this.tableData[index][keyWeight] +
                      "分，谢谢您的配合！";
                    throw Error();
                  }
                }
              }
            }
            total = window.$computeUtil.getPlus(
              total,
              Number(this.tableData[index][key])
            );
            total = new BigNumber(total).toFormat(2);
          }
        }
      } catch (e) {
        console.log(e);
      }
      if (flag) {
        this.$set(this.tableData[index], "supScore", total);
      } else {
        this.$message({
          message: message,
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    // 保存
    dealExpertSupScore() {
      if (this.tableData.length === 0) {
        this.$message({
          message: `分包商已全部淘汰，请联系采购承办人${
            JSON.parse(sessionStorage.getItem("expertSourceData")).expertName
          }进行流标操作`,
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      } else {
        let sscExpertSupScoreBOS = [];
        let flag = true;
        let message = "";
        // if (this.skillAndCommonTemp) {
        //
        // } else {
        //   try {
        //     this.tableData.forEach((item, index) => {
        //       let scoreItemIdArr = [];
        //       let obj = {};
        //       obj.supCode = item.supCode;
        //       obj.supName = item.supName;
        //       obj.supScore = item.supScore;
        //       obj.scoreDesc = item.scoreDesc;
        //       obj.scoreItem = "1";
        //       let sscSupScoreItemBOS = [];
        //       if (!item.scoreDesc) {
        //         flag = false;
        //         message = "第" + (index + 1) + "行的打分说明不能为空";
        //         throw Error();
        //       }
        //       for (let key in item) {
        //         if (key.includes("supScore-")) {
        //           // 不能大于权重大小
        //           for (let keyWeight in item) {
        //             if (keyWeight.includes("maxScoreWeight-")) {
        //               let scoreItem = key.substring(9, 10);
        //               let scoreWeightItem = keyWeight.substring(15, 16);
        //               let scoreItemId = key.substring(11);
        //               let scoreWeightItemId = keyWeight.substring(
        //                 keyWeight.lastIndexOf("-") + 1
        //               );
        //               let scoreRule = keyWeight.substring(
        //                 17,
        //                 keyWeight.lastIndexOf("-")
        //               );
        //               if (
        //                 scoreItem === scoreWeightItem &&
        //                 scoreItemId === scoreWeightItemId
        //               ) {
        //                 if (
        //                   Number(this.tableData[index][key]) >
        //                   Number(this.tableData[index][keyWeight])
        //                 ) {
        //                   flag = false;
        //                   message =
        //                     "第" +
        //                     (index + 1) +
        //                     "行的" +
        //                     scoreRule +
        //                     "的得分不允许大于细则权重" +
        //                     this.tableData[index][keyWeight] +
        //                     "分，谢谢您的配合！";
        //                   throw Error();
        //                 }
        //               }
        //             }
        //           }
        //           if (!Number(this.tableData[index][key])) {
        //             flag = false;
        //             message = "第" + (index + 1) + "行的评分不能为空";
        //             throw Error();
        //           }
        //           if (!scoreItemIdArr.includes(key)) {
        //             scoreItemIdArr.push(key);
        //             let sscScoreObj = {};
        //             sscScoreObj.scoreItemId = key.substring(11);
        //             sscScoreObj.supScore = this.tableData[index][key];
        //             sscSupScoreItemBOS.push(sscScoreObj);
        //           }
        //         }
        //       }
        //       obj.sscSupScoreItemBOS = sscSupScoreItemBOS;
        //       sscExpertSupScoreBOS.push(obj);
        //     });
        //   } catch (e) {
        //     console.log(e);
        //   }
        // }

        try {
          this.tableData.forEach((item, index) => {
            let tempSscExpertSupScoreBOS = []; // 技术商务评分的时候临时存的数据
            let scoreItemIdArr = [];
            // if (!item.scoreDesc) {
            //   flag = false;
            //   message = "第" + (index + 1) + "行的打分说明不能为空";
            //   throw Error();
            // }
            // let leng = this.validateTextLength(item.scoreDesc);
            // if (leng > 150) {
            //   flag = false;
            //   message =
            //     "第" + (index + 1) + "行的打分说明长度不能大于150，请重新输入";

            //   throw Error();
            // }
            for (let key in item) {
              if (key.includes("supScore-")) {
                // 不能大于权重大小
                for (let keyWeight in item) {
                  if (keyWeight.includes("maxScoreWeight-")) {
                    let scoreItem = key.substring(9, 10);
                    let scoreWeightItem = keyWeight.substring(15, 16);
                    let scoreItemId = key.substring(11);
                    let scoreWeightItemId = keyWeight.substring(
                      keyWeight.lastIndexOf("-") + 1
                    );
                    let scoreRule = keyWeight.substring(
                      17,
                      keyWeight.lastIndexOf("-")
                    );
                    if (
                      scoreItem === scoreWeightItem &&
                      scoreItemId === scoreWeightItemId
                    ) {
                      if (
                        Number(this.tableData[index][key]) >
                        Number(this.tableData[index][keyWeight])
                      ) {
                        flag = false;
                        message =
                          "第" +
                          (index + 1) +
                          "行的" +
                          scoreRule +
                          "的得分不允许大于细则权重" +
                          this.tableData[index][keyWeight] +
                          "分，谢谢您的配合！";
                        throw Error();
                      }
                    }
                  }
                }
                // 得分不能为空
                // if (!Number(this.tableData[index][key])) {
                //   flag = false;
                //   message = "第" + (index + 1) + "行的评分不能为空";
                //   throw Error();
                // }
                let obj = {};
                obj.supCode = item.supCode;
                obj.supName = item.supName;
                obj.supScore = item.supScore;
                obj.scoreDesc = item.scoreDesc;
                let sscSupScoreItemBOS = [];
                obj.scoreItem = key.substring(9, 10);
                if (!scoreItemIdArr.includes(key)) {
                  scoreItemIdArr.push(key);
                  let sscScoreObj = {};
                  sscScoreObj.scoreItemId = key.substring(11);
                  sscScoreObj.supScore = this.tableData[index][key];
                  sscSupScoreItemBOS.push(sscScoreObj);
                }
                obj.sscSupScoreItemBOS = sscSupScoreItemBOS;
                tempSscExpertSupScoreBOS.push(obj);
              }
            }
            let skillSscSupScoreItemBOS = []; // 技术
            let commonSscSupScoreItemBOS = []; // 商务
            let commonSscSupScoreItemBOS2 = []; // 技术加分项
            let commonSscSupScoreItemBOS3 = []; // 商务加分项
            tempSscExpertSupScoreBOS.forEach(temp => {
              if (temp.scoreItem == "0") {
                // 技术
                temp.sscSupScoreItemBOS.forEach(sscItem => {
                  skillSscSupScoreItemBOS.push(sscItem);
                });
              } else if (temp.scoreItem == "1") {
                // 商务
                temp.sscSupScoreItemBOS.forEach(sscItem => {
                  commonSscSupScoreItemBOS.push(sscItem);
                });
              } else if (temp.scoreItem == "2") {
                // 技术加分项
                temp.sscSupScoreItemBOS.forEach(sscItem => {
                  commonSscSupScoreItemBOS2.push(sscItem);
                });
              } else if (temp.scoreItem == "3") {
                // 商务加分项
                temp.sscSupScoreItemBOS.forEach(sscItem => {
                  commonSscSupScoreItemBOS3.push(sscItem);
                });
              }
            });
            if (this.skillAndCommonTemp) {
              skillSscSupScoreItemBOS.length > 0 &&
                sscExpertSupScoreBOS.push({
                  scoreItem: "0",
                  supCode: item.supCode,
                  supName: item.supName,
                  supScore: item.supScore,
                  scoreDesc: item.scoreDesc,
                  sscSupScoreItemBOS: skillSscSupScoreItemBOS
                });
              commonSscSupScoreItemBOS2.length > 0 &&
                sscExpertSupScoreBOS.push({
                  scoreItem: "2",
                  supCode: item.supCode,
                  supName: item.supName,
                  supScore: item.supScore,
                  scoreDesc: item.scoreDesc,
                  sscSupScoreItemBOS: commonSscSupScoreItemBOS2
                });
            }
            commonSscSupScoreItemBOS.length > 0 &&
              sscExpertSupScoreBOS.push({
                scoreItem: "1",
                supCode: item.supCode,
                supName: item.supName,
                supScore: item.supScore,
                scoreDesc: item.scoreDesc,
                sscSupScoreItemBOS: commonSscSupScoreItemBOS
              });
            commonSscSupScoreItemBOS3.length > 0 &&
              sscExpertSupScoreBOS.push({
                scoreItem: "3",
                supCode: item.supCode,
                supName: item.supName,
                supScore: item.supScore,
                scoreDesc: item.scoreDesc,
                sscSupScoreItemBOS: commonSscSupScoreItemBOS3
              });
          });
        } catch (e) {
          console.log(e);
        }
        console.log(sscExpertSupScoreBOS);
        if (flag) {
          let param = {
            schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .schemeId,
            packId: this.packId
              ? this.packId
              : this.$router.history.current.query.packId,
            packName: this.packName,
            joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .joinExpertId,
            expertName: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .expertName,
            purStep: this.$router.history.current.query.menuKey,
            scoreType: this.skillAndCommonTemp ? "2" : "1",
            sscExpertSupScoreBOS: sscExpertSupScoreBOS,
            isShowLoading: true,
            requestLimit: true
          };
          // console.log(param);
          // console.log(this.tableData);
          // let a = true;
          param.sscExpertSupScoreBOS.forEach(item => {
            let index = this.tableData.findIndex(
              ele => item.supCode == ele.supCode
            );
            item.noTaxPriceAmount = this.tableData[index].noTaxPriceAmount;
            item.priceAmount = this.tableData[index].priceAmount;
            item.supPackQuoteId = this.tableData[index].supPackQuoteId;
            item.supJoinId = this.tableData[index].supJoinId;
            item.supQuoteId = this.tableData[index].supQuoteId;
            item.taxAmount = this.tableData[index].taxAmount;
          });
          // console.log("this.tableData[index]", this.tableData);
          console.log(param);
          // let obj = [];
          // let a = true;
          // if (a) {
          //   return;
          // }
          scpDealExpertSupScoreApi(param).then(res => {
            this.$message({
              message: "评分表保存成功",
              type: "success",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            this.$router.push({
              name: "scpCommercialGradeList",
              query: {
                backPageSkillAndCommon: this.skillAndCommonTemp ? "1" : "2", // 商务技术：1 商务：2
                a: this.$router.history.current.query.a,
                menuKey: this.$router.history.current.query.menuKey,
                evaPurStep: this.$router.history.current.query.evaPurStep
              }
            });
          });
        } else {
          this.$message({
            message: message,
            type: "error",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
        }
      }
    },
    //导出评分模版
    exportExcel() {
      console.log("columns", this.columns);
      let sortIdsList = ["技术", "商务", "技术加分项", "商务加分项"];

      let sortIds = [];
      this.columns.forEach(item => {
        // if (sortIdsList.includes(item.label)) {
        if (sortIdsList.includes(item.label) && item.labelChild.length > 0) {
          console.log("aaa");
          for (let i = 0; i < sortIdsList.length; i++) {
            if (item.label == sortIdsList[i]) {
              sortIds.push(i);
            }
          }
        }
      });
      sortIds = sortIds.join(",");
      console.log("sortIds", sortIds);

      console.log("导出");
      let param = {
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        packId: this.packId
          ? this.packId
          : this.$router.history.current.query.packId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        scoreItem: this.skillAndCommonTemp ? "" : "1",
        sortIds
      };
      scpExportSupQuoteScoreFile(param).then(res => {
        if (res) {
          console.log(res);
          let openUrl = document.createElement("a");
          openUrl.style.display = "none";
          openUrl.href = res.data.data.fileUrl;
          openUrl.setAttribute("download", "评分模板.xlsx");
          document.body.appendChild(openUrl);
          openUrl.click();
        }
      });
    },
    //导入模板
    beforeAvatarUpload(file) {
      this.uploadLoading = true;
      const isLt50 = file.size < 52428800;
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        testmsg === "xlsx" ||
        testmsg === "xls" ||
        testmsg === "XLSX" ||
        testmsg === "XLS";
      if (!isLt50) {
        this.$message({
          message: "文件大小不可超过50M！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
      //是否有后缀
      let fileType = file.name.indexOf(".") != -1;
      if (!extension && fileType) {
        this.$message({
          message: "上传文件格式错误！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        // this.$showErrorMessage("上传文件格式错误！");
      }
      return isLt50 && (extension || !fileType);
    },
    uploadSuccess(res, file, fileList) {
      let schemeId = JSON.parse(sessionStorage.getItem("expertSourceData"))
        .schemeId;
      let packId = this.packId
        ? this.packId
        : this.$router.history.current.query.packId;
      let scoreType = this.skillAndCommonTemp ? "2" : "1";
      let lastPackId = packId ? packId : null;
      if (
        res.data.schemeId == schemeId &&
        res.data.packId == lastPackId &&
        res.data.scoreType == scoreType
      ) {
        res.data.sscExpertSupScoreBOS.forEach(item => {
          item.sscSupScoreItemBOS.forEach(bb => {
            let props = "supScore-" + bb.scoreItem + "-" + bb.scoreItemId;
            this.tableData.forEach((cc, index) => {
              if (cc.supCode == item.supCode) {
                cc[props] =
                  bb.supScore !== ""
                    ? new BigNumber(bb.supScore).toFormat(2)
                    : "";
                cc.supScore =
                  item.supScore !== ""
                    ? new BigNumber(item.supScore).toFormat(2)
                    : "";
                let leng = this.validateTextLength(item.scoreDesc);
                if (leng > 150) {
                  this.$message({
                    message:
                      "第" +
                      (index + 1) +
                      "行的打分说明长度不能大于150，请重新输入",
                    type: "error",
                    duration: 3000,
                    showClose: true,
                    ccuiCustom: true
                  });

                  throw Error();
                } else {
                  this.$set(cc, "scoreDesc", item.scoreDesc);
                }
              }
            });
          });
        });
      } else {
        this.$message({
          message: "导入模板与当前评标表不一致，请重新导入",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    uploadError(err, file, fileList) {
      this.$message({
        message: err.message,
        type: "error",
        duration: 3000,
        showClose: true,
        ccuiCustom: true
      });
    },
    //判断文字长度
    validateTextLength(value) {
      // 中文、中文标点、全角字符按1长度，英文、英文符号、数字按0.5长度计算
      let cnReg = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60])/g;
      let mat = value.match(cnReg);
      let length;
      if (mat) {
        length = mat.length + (value.length - mat.length) * 0.5;
        return length;
      } else {
        return value.length * 0.5;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.star {
  color: #ff1818;
}
.wd2 {
  width: 20px;
}
.wd6 {
  width: 60px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}
/deep/ .el-table td {
  padding: 0 !important;
}
.priamryColor {
  color: #0089ef;
  cursor: pointer;
}
.exportStyle {
  text-align: right;
  margin-bottom: 16px;
  .upload-demo {
    float: right;
    margin-left: 16px;
  }
}
</style>
